import { render, staticRenderFns } from "./OnboardingPush.vue?vue&type=template&id=45bbd863&"
import script from "./OnboardingPush.vue?vue&type=script&lang=js&"
export * from "./OnboardingPush.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports